const emoji = [
    {
      id: 1,
      emoji: "💪",
      name: "Tense Biceps",
      meaning:
        "“You can do that!” or “I feel strong!” Arm with tense biceps. Also used in connection with doing sports, e.g. at the gym."
    },
    {
      id: 2,
      emoji: "🙏",
      name: "Person With Folded Hands",
      meaning:
        "Two hands pressed together. Is currently very introverted, saying a prayer, or hoping for enlightenment. Is also used as a “high five” or to say thank you."
    },
    {
      id: 3,
      emoji: "🤣",
      name: "Rolling On The Floor, Laughing",
      meaning:
        "This is funny! A smiley face, rolling on the floor, laughing. The face is laughing boundlessly. The emoji version of “rofl“. Stands for „rolling on the floor, laughing“."
    },
    {
      id: 4,
      emoji: "🤔",
      name: "Thinking Face",
      meaning:
        "A yellow face with furrowed eyebrows looking upwards with thumb and index finger resting on its chin. Intended to show a person pondering or deep in thought. Often used to question or scorn something or someone, as if saying Hmm, I don't know about that. Tone varies, including earnest, playful, puzzled, skeptical, and mocking."
    },
    {
        id: 5,
        emoji: "😋",
        name: "Face Savoring Food",
        meaning:
          "A yellow face with smiling eyes and a broad, closed smile with its tongue sticking out of one corner, as if licking its lips in appetite or contentment. Widely used to convey that a food item is delicious. May also express that a person is attractive."
    },
    {
        id: 6,
        emoji: "😉",
        name: "Winking Face",
        meaning:
          "A yellow face with a slight smile or open mouth shown winking, usually its left eye. May signal a joke, flirtation, hidden meaning, or general positivity. Tone varies, including playful, affectionate, suggestive, or ironic."
    },
    {
        id: 7,
        emoji: "😄",
        name: "Grinning Face with Smiling Eyes",
        meaning:
          "A yellow face with smiling eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general happiness and good-natured amusement."
    },
    {
        id: 8,
        emoji: "💀",
        name: "Skull",
        meaning:
          "A whitish-gray, cartoon-styled human skull with large, black eye sockets. Commonly expresses figurative death, e.g., dying from extreme laughter, frustration, or affection."
    },
    {
        id: 9,
        emoji: "🔥",
        name: "Fire",
        meaning:
          "A flame, as produced when something is on fire. Depicted as a red, orange, and yellow flickering flame.Commonly used for various metaphorical expressions related to fire, including the slang hot (“attractive”) and lit (“excellent”)."
    },
    {
        id: 10,
        emoji: "👀",
        name: "Eyes",
        meaning:
          "A pair of eyes, glancing slightly to the left on most platforms. The Google version of this emoji previously showed only a single eye, despite the name of this character being eyes (plural)."
    },
    {
        id: 11,
        emoji: "🎈",
        name: "Balloon",
        meaning:
          "A balloon on a string, as decorates a birthday party. Generally depicted in red, though WhatsApp’s is pink and Google’s orangish-red."
    },
    {
        id: 12,
        emoji: "🎂",
        name: "Birthday Cake",
        meaning:"A balloon on a string, as decorates a birthday party. Generally depicted in red, though WhatsApp’s is pink and Google’s orangish-red."
       
    },
    {
        id: 13,
        emoji: "🎁",
        name: "Wrapped Gift",
        meaning:"A present or gift in a box tied with a bow, as given on a birthday or Christmas. Box and ribbon color vary across platforms, but commonly depicted as a gold box with a lid wrapped with a red ribbon.        Commonly used to represent gifts and presents on various holidays, celebrations, and special occasions."
    },
    {
        id: 14,
        emoji: "🙌",
        name: "Raising Hands",
        meaning:
          "Two hands raised in the air, celebrating success or another joyous event.          Originally animated to show hands being raised, as might be done along with the the exclamation Banzai! in Japan. Now more commonly only shows the hands in the air."
    },
    {
        id: 15,
        emoji: "😴",
        name: "Sleeping Face",
        meaning:
          "A yellow face with eyes closed and mouth letting out three, cartoon-styled Zzz’s overhead to indicate it's sound asleep. The Zzz’s appear blue or purple across most platforms. May also represent boredom (slang, snooze)."
    },
    {
        id: 16,
        emoji: "🤮",
        name: "Face Vomiting",
        meaning:
          "A yellow face with scrunched, X-shaped eyes spewing bright-green vomit. May represent physical illness or disgust, more intensely so than 🤢 Nauseated Face."
    },
    {
        id: 17,
        emoji: "🤧",
        name: "Sneezing Face",
        meaning:
          "A yellow face with scrunched, X-shaped eyes sneezing or blowing its nose into a white tissue, as if from a cold or allergies. Often depicted with a crumpled-looking mouth."
    },
    {
        id: 18,
        emoji: "🤯",
        name: "Exploding Head",
        meaning:
          "A yellow face with an open mouth, the top of its head exploding in the shape of a brain-like mushroom cloud. A visual form of the expression mind blown, it may represent such emotions as shock, awe, amazement, and disbelief."
    },
    {
      id: 19,
      emoji: "⚽",
      name: "Football",
      meaning:
        "A round, black and white ball used in the game of football in much of the world."
    },
    {
      id: 20,
      emoji: "🥭",
      name: "Mango",
      meaning:
        "The ripe fruit of a tropical mango. Variously depicted in shades of yellow, red, orange, and green with a single, green leaf and stem."
    },
    {
      id: 21,
      emoji: "✈️",
      name: "Airplane",
      meaning:
        "Used either as a literal airplane, to represent an overseas vacation, or sometimes as a proxy for airplane mode on a phone or tablet."
    },

  ];
  export default emoji;